import { useState, useEffect } from "react";
import useForm from "antd/es/form/hooks/useForm";
import request from "project-config/services/request/request";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "@/store/GlobalStore";

export function useChangeCompany() {
  const [openCompanyModal, setOpenCompanyModal] = useState(false);
  const [changeCompanyForm] = useForm();
  const [changeCompanyLoading, setChangeCompanyLoading] = useState(false);
  const { fetchUserData, userInfo } = useGlobalStore();

  const { t } = useTranslation("error");
  const submitChangeCompany = () => {
    setChangeCompanyLoading(true);

    changeCompanyForm
      .validateFields()
      .then(async () => {
        const company = changeCompanyForm.getFieldValue("company");
        const companySite = changeCompanyForm.getFieldValue("companySite");
        const vatNumber = changeCompanyForm.getFieldValue("vatNumber");
        const { code } = await request.post(
          "/api/rendering/user/updateCompanyInfo",
          {
            company,
            companySite,
            vatNumber,
          }
        );

        setChangeCompanyLoading(false);

        if (code === 200) {
          message.success(t(`update_success`));
          fetchUserData();
          clearChangeCompanyForm();
        }
      })
      .catch(() => {
        setChangeCompanyLoading(false);
      });
  };

  const clearChangeCompanyForm = () => {
    setChangeCompanyLoading(false);
    setOpenCompanyModal(false);
  };

  useEffect(() => {
    if (userInfo) {
      changeCompanyForm.setFieldsValue({
        company: userInfo.company,
        companySite: userInfo.companySite,
        vatNumber: userInfo.vatNumber,
      });
    }
  }, [userInfo, openCompanyModal, changeCompanyForm]);

  return {
    openCompanyModal,
    setOpenCompanyModal,
    changeCompanyForm,
    changeCompanyLoading,
    submitChangeCompany,
    clearChangeCompanyForm,
  };
}
